import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { RequestError } from "@octokit/request-error";

function requestToOAuthBaseUrl(request) {
  var endpointDefaults = request.endpoint.DEFAULTS;
  return /^https:\/\/(api\.)?github\.com$/.test(endpointDefaults.baseUrl) ? "https://github.com" : endpointDefaults.baseUrl.replace("/api/v3", "");
}

function oauthRequest(_x, _x2, _x3) {
  return _oauthRequest.apply(this, arguments);
}

function _oauthRequest() {
  _oauthRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(request, route, parameters) {
    var withOAuthParameters, response, error;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            withOAuthParameters = _objectSpread({
              baseUrl: requestToOAuthBaseUrl(request),
              headers: {
                accept: "application/json"
              }
            }, parameters);
            _context.next = 3;
            return request(route, withOAuthParameters);

          case 3:
            response = _context.sent;

            if (!("error" in response.data)) {
              _context.next = 8;
              break;
            }

            error = new RequestError("".concat(response.data.error_description, " (").concat(response.data.error, ", ").concat(response.data.error_uri, ")"), 400, {
              request: request.endpoint.merge(route, withOAuthParameters),
              headers: response.headers
            });
            error.response = response;
            throw error;

          case 8:
            return _context.abrupt("return", response);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _oauthRequest.apply(this, arguments);
}

export { oauthRequest, requestToOAuthBaseUrl };